console.log("Load: JS Theme");

//Swiper
import Swiper from "swiper";
import {Navigation, Autoplay, EffectCreative} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';

//Lazyload
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset.js';

import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';
import mapStyle from './mapStyle.json';

//Grid images
import MasonryPkg from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

const Masonry = MasonryPkg.default || MasonryPkg;


/** region swiper **/
const swiper2 = new Swiper('.slider-2', {
    modules: [Navigation, Autoplay],
    loop: true,
    loopAdditionalSlides: 2,
    centeredSlides: true,
    autoplay: {
        waitForTransition: true,
        delay: 10000,
        disableOnInteraction: false
    },
    speed: 1300,
    slidesPerView: 1.2,
    spaceBetween: 10, //px
    breakpointsBase: 'container',
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 10 //px
        },
        1024: {
            slidesPerView: 2.1,
            spaceBetween: 20 //px
        },
        1280: {
            slidesPerView: 2.8,
            spaceBetween: 30 //px
        }
    },
    navigation: {
        nextEl: '.slider-2-button-next',
        prevEl: '.slider-2-button-prev'
    },
    observer: true,
    observeParents: true,
    on: {
        init(swiper) {
            swiper.slideToLoop(0, 0, false);
        }
    }
})
const swiper2_style2 = new Swiper('.slider-2-style2', {
    modules: [Navigation, Autoplay],
    loop: true,
    autoplay: {
        waitForTransition: true,
        delay: 8000,
        disableOnInteraction: false
    },
    speed: 1300,
    slidesPerView: 1,
    spaceBetween: 10, //px
    breakpointsBase: 'container',
    navigation: {
        nextEl: '.slider-2-style2-button-next',
        prevEl: '.slider-2-style2-button-prev'
    },
    observer: true,
    observeParents: true,
    on: {
        init(swiper) {
            swiper.slideToLoop(0, 0, false);
        }
    }
})
const swiper2_style3 = new Swiper('.slider-2-style3', {
    modules: [Navigation, Autoplay],
    loop: true,
    centeredSlides: true,
    autoplay: {
        waitForTransition: true,
        delay: 10000,
        disableOnInteraction: false
    },
    speed: 1300,
    slidesPerView: 1.2,
    spaceBetween: 10, //px
    breakpointsBase: 'container',
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 10 //px
        },
        1024: {
            slidesPerView: 2.1,
            spaceBetween: 20 //px
        },
        1280: {
            slidesPerView: 2.4,
            spaceBetween: 30 //px
        }
    },
    navigation: {
        nextEl: '.slider-2-style3-button-next',
        prevEl: '.slider-2-style3-button-prev'
    },
    observer: true,
    observeParents: true
})
/** endregion swiper **/

/** region Maplibregl **/
window.addEventListener('DOMContentLoaded', function () {
    setTimeout(function(){
        let section_maps = document.querySelectorAll('section[data-type="map"]');
        if(section_maps){
            section_maps.forEach( section => {
                let id_element = section.getAttribute('data-id');
                let longitude = section.getAttribute('data-longitude');
                let latitude = section.getAttribute('data-latitude');
                if(!id_element || !latitude || !longitude || parseFloat(latitude) == NaN || parseFloat(longitude) == NaN) return;

                let longitude_float = parseFloat(longitude);
                let latitude_float = parseFloat(latitude);

                if (!document.getElementById('container_map_'+id_element)) return;

                var map = new maplibregl.Map({
                    container: 'container_map_'+id_element,
                    style: mapStyle,
                    center: [longitude_float,latitude_float],
                    zoom: 16,
                    attributionControl: false
                })

                map.on('load', function (){
                    const marker = document.getElementById('marker_'+id_element);
                    if(marker){
                        marker.classList.remove('hidden')
                        new maplibregl.Marker({ element: marker})
                            .setLngLat([longitude_float,latitude_float])
                            .addTo(map)
                    }
                })
            })
        }
    },500)

    createGridImages();
});

/** endregion Maplibregl **/

/** region functions **/
function toggleMenuDishes(id, menus_divs, menus_links) {
    let el = document.getElementById(id);
    if (!el) return;

    let status = el.getAttribute('data-status');
    let class_items = document.getElementsByClassName(menus_divs);
    let menus_links_items = document.getElementsByClassName(menus_links);

    for (let item of menus_links_items) {
        if (item.getAttribute('data-id') == id) {
            item.classList.add('active');
        } else {
            item.classList.remove('active');
        }
    }

    for (let item of class_items) {
        item.setAttribute('data-status', 'close');
    }

    el.setAttribute('data-status', 'open');
}

window.toggleMenuDishes = toggleMenuDishes;
function splitLinesEffect() {
    document.querySelectorAll('.split-lines h2').forEach(h2 => {
        const words = h2.textContent.trim().split(' ');
        h2.innerHTML = words.map(word =>
            `<span class="word">${
                word.split('').map(c =>
                    `<span class="char">${c}</span>`
                ).join('')
            }</span>`
        ).join('');
    });

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const h2 = entry.target;
                h2.querySelectorAll('.char').forEach((c, i) => {
                    c.style.transitionDelay = `${i * 30}ms`;
                });
                h2.classList.add('is-visible');
                observer.unobserve(h2);
            }
        });
    }, { threshold: 0.2 });

    document.querySelectorAll('.split-lines h2').forEach(h => observer.observe(h));
}
function createGridImages() {
    const grids = document.querySelectorAll('.images-grid');
    if (!grids) return;

    grids.forEach(grid => {
        let gutter = 16;
        if (grid.getAttribute('data-gutter') && !isNaN(grid.getAttribute('data-gutter'))) {
            try {
                gutter = Number.parseInt(grid.getAttribute('data-gutter'));
            } catch (e) {
                gutter = 16;
                console.warn("Can't do Number.parseInt for createGridImages");
            }
        }

        const msnry = new Masonry(grid, {
            itemSelector: '.grid-item',
            columnWidth: '.grid-item', // uses width of first item
            gutter: gutter,                 // space between items in px
            percentPosition: true       // use percentages
        });

        imagesLoaded(grid, () => {
            msnry.layout(); // fixes layout after images load
        });
    })
}

window.createGridImages = createGridImages;
/** endregion functions **/


document.addEventListener('DOMContentLoaded', splitLinesEffect);

